import { render } from "./MainDVThuChiHo.vue?vue&type=template&id=5b94d61a"
import script from "./MainDVThuChiHo.vue?vue&type=script&lang=js"
export * from "./MainDVThuChiHo.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__